// Seller net sheet math, shared by the app (Tools > Seller Net Sheet) and the MCP seller_net_sheet tool.
// CommonJS, no imports. Florida owner's title rates: Fla. Admin. Code R. 69O-186.003(1), per $1,000, tiered, $100 minimum.
const TITLE_TIERS = [
  { upTo: 100000, rate: 5.75 },
  { upTo: 1000000, rate: 5.0 },
  { upTo: 5000000, rate: 2.5 },
  { upTo: 10000000, rate: 2.25 },
  { upTo: Infinity, rate: 2.0 },
];
function floridaOwnersTitlePremium(price) {
  const p = Math.max(Number(price) || 0, 0);
  if (p <= 0) return 0;
  let prev = 0; let total = 0;
  for (const t of TITLE_TIERS) {
    if (p <= prev) break;
    total += ((Math.min(p, t.upTo) - prev) / 1000) * t.rate;
    prev = t.upTo;
  }
  return Math.max(Math.round(total * 100) / 100, 100);
}
const num = (v) => { const n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.-]/g, '')); return Number.isFinite(n) ? n : 0; };
const NET_SHEET_DEFAULTS = {
  price: '', sellerCommPct: '3', buyerCommPct: '2.5', docStampsPct: '0.70',
  propertyType: 'resale', ownerTitlePayer: 'seller', ownerTitle: '', title: '', closing: '', payoff: '', otherLiens: '', hoaTransfer: '', taxProration: '', repairs: '', credits: '',
};
// v = the net sheet form values (strings or numbers). Returns every line and the estimated net.
function computeNetSheet(v) {
  const price = num(v.price);
  const sellerComm = price * num(v.sellerCommPct) / 100;
  const buyerComm = price * num(v.buyerCommPct) / 100;
  const docStamps = price * num(v.docStampsPct) / 100;
  const title = num(v.title); const closing = num(v.closing); const payoff = num(v.payoff); const liens = num(v.otherLiens);
  const hoa = num(v.hoaTransfer); const proration = num(v.taxProration); const repairs = num(v.repairs); const credits = num(v.credits);
  const ownerTitleCost = v.ownerTitlePayer === 'seller' ? (v.ownerTitle !== '' && v.ownerTitle != null ? num(v.ownerTitle) : floridaOwnersTitlePremium(price)) : 0;
  const totalCosts = sellerComm + buyerComm + docStamps + ownerTitleCost + title + closing + hoa + proration + repairs + credits;
  const net = price - totalCosts - payoff - liens;
  return { price, sellerComm, buyerComm, docStamps, ownerTitleCost, title, closing, payoff, liens, hoa, proration, repairs, credits, totalCosts, net };
}
module.exports = { floridaOwnersTitlePremium, computeNetSheet, NET_SHEET_DEFAULTS, netSheetNum: num };
